import React, { FC } from 'react';

import { IcSpeedIcon } from '@gem/icons';

import { IconButton, IconViewSizes } from '../../../IconButton/IconButton';
import { PopoverMenu } from '../../../PopoverMenu/PopoverMenu';
import { IVideoPlayerSpeedProps, useVideoPlayerSpeedPresenter } from './VideoPlayerSpeed.presenter';
import styles from './VideoPlayerSpeed.styles.m.css';

export const VideoPlayerSpeed: FC<IVideoPlayerSpeedProps> = (props) => {
  const presenter = useVideoPlayerSpeedPresenter(props);

  return (
    <>
      <IconButton
        className={styles.actionButton}
        setRef={presenter.popover.containerRef}
        Icon={IcSpeedIcon}
        size={IconViewSizes.XSmall}
        iconSize={IconViewSizes.Medium}
        theme="19"
        onClick={presenter.togglePopover}
      />

      <PopoverMenu
        className={styles.menu}
        menuClassName={styles.menuItem}
        isOpened={presenter.popover.isOpened}
        menuItems={presenter.menuItems}
        onClose={presenter.closePopover}
        reference={presenter.popover.containerRef.current}
        placement="top-end"
        theme="dark"
      />
    </>
  );
};
